import React from 'react';

import { ErrorCard } from '@eika/card';

import { DebitCardOrderResponse } from '@generated-types';
import useText from '@hooks/use-text';

const SigningOrderErrorView = ({ cardOrder }: { cardOrder: DebitCardOrderResponse | undefined | null }) => {
    const { signingOrderFailedError, signingOrderMissingError } = useText();

    const description = cardOrder ? signingOrderFailedError : signingOrderMissingError;

    return <ErrorCard title="" description={description} />;
};

export default SigningOrderErrorView;
